import { createFileRoute, notFound } from "@tanstack/react-router";

import { serviceJobsQueries } from "@/api/resources/serviceJobs/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import ServiceJobPage from "@/components/ServiceJob/ServiceJobPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/service-jobs/$service_job_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.service-jobs"),
        icon: <Icon.SERVICE_JOBS />,
        path: "/workspaces/$workspace_id/service-jobs",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, service_job_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentServiceJob = await context.queryClient.ensureQueryData(serviceJobsQueries.byId(service_job_id));
    if (!currentServiceJob) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [{ label: currentServiceJob.name, icon: <Icon.SERVICE_JOB /> }];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);
  },
  component: ServiceJobPage,
});
